module.exports = __webpack_public_path__ + "img/IconMedicalNutritionTherapy.8a1958a9.svg";